import React, { useState } from 'react';
import { cn } from '../../lib/classNames';

function initials(nome, cognome) {
  const a = (nome || '').trim().charAt(0);
  const b = (cognome || '').trim().charAt(0);
  const s = `${a}${b}`.toUpperCase();
  return s || '?';
}

/**
 * Avatar medico: foto con aspect fisso, oppure iniziali (mai spinner infinito).
 */
export function DoctorAvatar({
  src,
  nome,
  cognome,
  size = 72,
  className = '',
  alt,
}) {
  const [broken, setBroken] = useState(false);
  const showImg = src && !broken;
  const label = alt || [nome, cognome].filter(Boolean).join(' ') || 'Medico';

  return (
    <span
      className={cn('vc-doctor-avatar', className)}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
      aria-hidden={showImg ? undefined : true}
    >
      {showImg ? (
        <img
          src={src}
          alt={label}
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          onError={() => setBroken(true)}
        />
      ) : (
        <span className="vc-doctor-avatar__fallback">{initials(nome, cognome)}</span>
      )}
    </span>
  );
}

export default DoctorAvatar;
